export type MetaGetter = (name: string) => string | null;

export const getMeta: MetaGetter = (name: string): string | null => {
	const node = document.querySelector(`meta[name="${name}"]`);
	const metaValue = node && node.getAttribute('content');
	return metaValue !== undefined ? metaValue : null;
};

export default getMeta;
